import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { LayoutActionLoadError } from '@shared/store/actions/layout.action';

import { StoreStockRecallListService } from '../../service/store-stock-recall-list.service';
import {
  loadStoreStockRecallListRequest,
  loadStoreStockRecallListResponse,
  storeStockRecallViewAction
} from './store-stock-recall-list.action';

@Injectable()
export class StoreStockRecallListEffect {
  constructor(
    private readonly actions$: Actions,
    private readonly logger: NGXLogger,
    private service: StoreStockRecallListService
  ) {}

  loadStoreStockRecallListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadStoreStockRecallListRequest),
      tap(action =>
        this.logger.debug('@Effect Load Store Stock Recall List Request: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap(action => {
        return this.service.getStoreStockRecallList(action.criteriaObj).pipe(
          map((data: any) => loadStoreStockRecallListResponse({ data })),
          catchError(err => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  loadStoreStockRecallViewRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(storeStockRecallViewAction.view),
      tap(action =>
        this.logger.debug('@Effect Load Store Stock Recall View Request: ' + JSON.stringify(action.docNo))
      ),
      switchMap(action => {
        return this.service.getStoreStockRecallView(action.docNo).pipe(
          map((data: any) => storeStockRecallViewAction.viewResponse({ response: data })),
          catchError(err => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
